module.exports = __webpack_public_path__ + "static/media/disfraz-niño.cc3f8dbd.jpg";